import { render, staticRenderFns } from "./app-menu.vue?vue&type=template&id=585fa909"
import script from "./app-menu.vue?vue&type=script&lang=js"
export * from "./app-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports